import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "23",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M12.905 9.97 20.35 1.5h-1.764L12.12 8.853 6.956 1.5H1l7.809 11.12L1 21.5h1.764l6.827-7.766 5.453 7.766H21M3.4 2.802h2.71l12.476 17.46h-2.71"
    }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }